module.exports = __webpack_public_path__ + "img/truss_head_sku.prt.f21a1042.jpg";